var React = require('react');

function Router (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"white","fillOpacity":"0.1","key":0}),React.createElement("path",{"d":"M24 13C17.95 13 13 17.95 13 24C13 30.05 17.95 35 24 35C30.05 35 35 30.05 35 24C35 17.95 30.05 13 24 13ZM24 32.8C19.138 32.8 15.2 28.862 15.2 24C15.2 19.138 19.138 15.2 24 15.2C28.862 15.2 32.8 19.138 32.8 24C32.8 28.862 28.862 32.8 24 32.8ZM25.1 25.1V28.4H27.3L24 31.7L20.7 28.4H22.9V25.1M16.3 25.1H19.6V27.3L22.9 24L19.6 20.7V22.9H16.3M22.9 22.9V19.6H20.7L24 16.3L27.3 19.6H25.1V22.9M31.7 22.9H28.4V20.7L25.1 24L28.4 27.3V25.1H31.7","fill":"white","fillOpacity":"0.8","key":1})]);
}

Router.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Router;

Router.default = Router;
